import type { ShootTransaction } from '@diana/contracts';
export function financeSummary(price: number | null, items: readonly ShootTransaction[]) {
  const received = items
    .filter((item) => item.kind === 'Income')
    .reduce((sum, item) => sum + item.amountMinor, 0);
  const expenses = items
    .filter((item) => item.kind === 'Expense')
    .reduce((sum, item) => sum + item.amountMinor, 0);
  return {
    received,
    expenses,
    net: received - expenses,
    remaining: price === null ? null : Math.max(0, price - received),
    overpaid: price === null ? 0 : Math.max(0, received - price),
    percent: price === null || price === 0 ? null : Math.min(100, (received / price) * 100),
    status:
      price === null
        ? 'Price not set'
        : received >= price
          ? 'Paid'
          : received > 0
            ? 'Partially paid'
            : 'Unpaid',
  };
}
export function parseTransactionAmount(value: string) {
  const normalized = value.trim().replace(',', '.');
  if (!/^\d{1,8}(\.\d{1,2})?$/.test(normalized)) return null;
  const [whole, fraction = ''] = normalized.split('.');
  const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return amount > 0 && amount <= 2147483647 ? amount : null;
}
export function todayInLisbon() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Lisbon',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const part = (type: string) => parts.find((item) => item.type === type)!.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}
